module.exports = __webpack_public_path__ + "static/media/greencard.42f358e3.jpg";